import { render } from "./PayModalSectionBanks.vue?vue&type=template&id=40ae9abd"
import script from "./PayModalSectionBanks.vue?vue&type=script&lang=js"
export * from "./PayModalSectionBanks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__